import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cmsClient } from "src/services/cmsClient";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";

const createObservationCategory = async ({
	name,
	audienceGroupIds
}: {
	name: string;
	audienceGroupIds?: number[];
}) => {
	const url = "/observations/admin/forms/categories/";
	const response = await cmsClient.post(url, {
		name,
		audience_group_ids: audienceGroupIds ?? []
	});

	return response.data;
};

const useCreateObservationCategory = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["observation-categories"]);

		toast.success(
			<CustomToast type="Success" message="Category created successfully" />,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutationFn = createObservationCategory;

	const mutation = useMutation({
		mutationFn,
		onSuccess,
		onError
	});

	return mutation;
};

export default useCreateObservationCategory;
